import { UpdatePaymentTradesAdditionsApi } from "@/features/accounts/payment/scraping/services/update-trades-additions-api";
import { UpdatePaymentTradesAdditionsRequestModel } from "@/features/accounts/payment/scraping/services/update-trades-additions-model";

/// MoneyLook明細メモ・無効明細更新処理
export class UpdatePaymentTradesAdditionsService {
  private updatePaymentTradesAdditionsApi = new UpdatePaymentTradesAdditionsApi();

  /**
   * MoneyLook明細メモ・無効明細更新API実行
   */
  public async updatePaymentTradesAdditions(param: UpdatePaymentTradesAdditionsRequestModel) {
    return await this.updatePaymentTradesAdditionsApi.updatePaymentTradesAdditions(param);
  }
}
